<template>
  <div class="root">
    <!-- <pageHeader></pageHeader> -->
    <HomepageHeader v-if="isShowTop"></HomepageHeader>
    <div class="homebanner">
      <!-- 轮播图 -->
      <div class="wrap_content">
        <swiper class="swiper" :options="swiperOption">
          <swiper-slide
            v-for="(item, index) in bannerlist"
            :key="'certificate' + index"
          >
            <div class="divimg">
              <img
                :src="item"
                :alt="'certificate' + index"
                style="vertical-align: middle; height: 650px"
              />
            </div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>

      <div class="content">
        <!-- 解决方案 -->
        <div class="info-wrap">
          <div class="title-row">
            <p class="line"></p>
            <div class="title">解决方案111111111111</div>
            <div class="sub-title">SOLUTIONS</div>
          </div>
          <div class="info-content">
            <div class="solution" @click="soultiondetail(0)" id="solution1">
              <div class="content">
                <div class="title">
                  <!-- <img src="/static/images/home/tinified/solution3.png" alt=""> -->
                  <img
                    :src="img_src.solution1"
                    style="width: 34px; height: 34px; margin-bottom: 10px"
                    alt
                  />
                  慢病管理解决方案
                </div>
                <p class="descript">
                  数字慢病管理云平台是基于云端的灵活可配置的健康数字化管理服务平台，具备四大端口、双向转诊、互通共享的核心优势。便于医生团队实时监管居民健康状况，使医院实现无纸化办公，便于卫健委为人民群众提供全方位全周期健康服务，为健康中国2030赋能。
                </p>
                <!-- <button class="btn">点击</button> -->
                <div>
                  <img
                    :src="img_src.solutionenter"
                    style="
                      width: 34px;
                      height: 14px;
                      margin-top: 190px;
                      display: flex;
                      justify-content: end;
                    "
                    alt
                  />
                </div>
              </div>
            </div>
            <div class="solution" @click="soultiondetail(1)" id="solution2">
              <div class="content">
                <div class="title">
                  <img
                    :src="img_src.solution2"
                    style="width: 34px; height: 32px; margin-bottom: 10px"
                    alt
                  />
                  动态心电监测解决方案
                </div>
                <p class="descript">
                  目前医院门诊常用的心律失常无创检查方法为静息心电图，静息心电图仅获取患者10秒左右的心电图，由于心脏病本身突发性、间歌性、短暂性、致命性等特点，如果佩戴过程没有出现临床症状，检查结果就有不确定性，远程动态心电监测能对患者进行心电图检查可移动长时间实时监测、存储、分析提供准确性，为患者疾病预报和及时抢救提供重要诊断依据。
                </p>
                <!-- <button class="btn">点击</button> -->
                <div>
                  <img
                    :src="img_src.solutionenter"
                    style="width: 34px; height: 14px; margin-top: 190px"
                    alt
                  />
                </div>
              </div>
            </div>
            <div class="solution" @click="soultiondetail(2)" id="solution3">
              <div class="content">
                <div class="title">
                  <img
                    :src="img_src.solution3"
                    style="width: 30px; height: 30px; margin-bottom: 10px"
                    alt
                  />
                  医用耗材管理解决方案
                </div>
                <p class="descript">
                  医耗智能装备系统是一款软硬件结合智能化的信息化的管理手段，保证院内医用物资质量安全、
                  满足临床需求为宗旨；以信息系统和智能硬件为支撑；以专业化运营管理为手段；强化医院医用物资管理部门的全程监管，协调外部与内部需求为主导，对全院医用物资在院内的供应、加工、配送等物流的一体化服务
                </p>
                <!-- <button class="btn">点击</button> -->
                <div>
                  <img
                    :src="img_src.solutionenter"
                    style="width: 34px; height: 14px; margin-top: 190px"
                    alt
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- </div> -->
        </div>
        <!-- 服务案列 -->

        <div class="example-wrap">
          <div class="title-row">
            <p class="line"></p>
            <div class="title">服务案列</div>
            <div class="sub-title">ABOUT CASE</div>
          </div>
          <swiperchange
          class="swiperchange"
            :current_type="current_swiper"
            :typeList="exampletitle"
            @SwiperChange="SwiperChange($event)"
          ></swiperchange>
          <div class="div_example">
            <div v-for="(item, index) in examplelist" :key="index">
              <!-- <transition name="el-zoom-in-bottom"> -->
              <!-- <div v-show="isshow">
                <img
                  :src="examplelist[current_swiper]"
                  style="vertical-align: middle; width: 982px; height: 390px"
                />
              </div> -->
              <div v-show="item.isshow" class="transition-box">
                <img
                  :src="item.url"
                  style="vertical-align: middle; width: 1074px; height: 450px"
                />
              </div>
              <!-- </transition> -->
            </div>
            <!-- <img
              :src="examplelist[current_swiper][0]"
              style="vertical-align: middle; width: 490px; height: 390px"
            /> -->
            <!-- <img
              :src="examplelist[current_swiper][1]"
              style="vertical-align: middle; width: 230px; height: 390px"
            />
            <img
              :src="examplelist[current_swiper][2]"
              style="vertical-align: middle; width: 230px; height: 390px"
            /> -->
          </div>
        </div>
      </div>
      <!-- 图片 -->
      <!-- <img :src="img_src.homebg" alt /> -->
      <!-- 新闻中心 -->

      <div class="news-wrap" v-if="newslist.length > 0">
        <div class="title-row">
          <p class="line"></p>
          <div class="title">新闻中心</div>
          <div class="sub-title">NEWS</div>
        </div>
        <div class="news">
          <div class="div_newsimg" @click="newsdetail(topnewsurl)">
            <el-image
              class="topnewsimg"
              :src="topnewsimg"
              style="height: 320px; width: 400px"
              alt
              referrerPolicy="no-referrer"
            />
            <div class="topnewstitle">{{ topnewstitle }}</div>
          </div>
          <div style="display: flex; flex-direction: column">
            <div
              class="newslitst"
              v-for="(item, index) in newslist"
              :key="'newlist' + index"
              @click="newsdetail(newslist[index].url)"
            >
              <a href="#" onclick="return false">
                <div class="div-title">
                  <div class="title">{{ item.title }}</div>
                  <div class="date">{{ item.publishDate }}</div>
                </div>
                <div class="div-content">
                  <div class="content">{{ item.theAbstract }}</div>
                  <i class="el-icon-arrow-right iconcolor"></i>
                </div>
                <div class="progress2 progress-moved">
                  <div class="progress-bar1"></div>
                </div>
                <!-- <div class="line"> -->
                <!-- <el-progress
                    :percentage="item.progress"
                    :stroke-width="1"
                    color="#2525CC"
                    :show-text="false"
                  ></el-progress>-->
                <!-- </div> -->
              </a>
            </div>
          </div>
        </div>
        <div class="more" @click="lookmore">
          <a href="#" onclick="return false">查看更多</a>
        </div>
      </div>
      <HomepageFooter></HomepageFooter>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
// import 'swiper/swiper-bundle.css'
// import '../assets/idangerous.swiper.css'
// import "../assets/idangerous.swiper.min.js";
import HomepageHeader from "../Layout/HomeHeader.vue";
import HomepageFooter from "../Layout/HomeFooter.vue";
import swiperchange from "../../components/swiperchange.vue";
import { GetNews } from "../../utils/api";
export default {
  components: {
    Swiper,
    SwiperSlide,
    HomepageHeader,
    HomepageFooter,
    swiperchange,
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      radio1: "上海",
      top: 0, // 页面滚动高度
      isShowTop: true,
      isshow: true,
      topnewstitle: "",
      topnewsurl: "",
      topnewsimg: "",
      current_swiper: 0,
      iconColor: "#a2a2a2",
      img_src: {
        banner: "https://s1.ax1x.com/2022/04/06/qXoJED.png",
        info: "https://s1.ax1x.com/2022/04/06/qXo1u6.png",
        business1: "https://s1.ax1x.com/2022/04/06/qXoQjx.png",
        business2: "https://s1.ax1x.com/2022/04/06/qXoMg1.png",
        business3: "https://s1.ax1x.com/2022/04/06/qXoK3R.png",
        news: "https://s1.ax1x.com/2022/04/06/qXo8HO.png",
        qrCode: "https://s1.ax1x.com/2022/04/06/qXo3DK.png",
        solution1: "/static/images/home/tinified/solutionicon1.png",
        solution2: "/static/images/home/tinified/solutionicon2.png",
        solution3: "/static/images/home/tinified/solutionicon3.png",
        solutionenter: "/static/images/home/tinified/solutionenter.png",
        homebg: "https://s1.ax1x.com/2022/10/12/xUqQxI.png",
        newsimg: "https://s1.ax1x.com/2022/10/12/xUqYdS.png",
      },
      //轮播图
      bannerlist: [
        // "/static/images/home/tinified/homebanner.png",
        // "/static/images/home/tinified/homebanner.png",
        // "/static/images/home/tinified/homebanner.png",
        // "/static/images/home/tinified/homebanner.png",
        "https://s1.ax1x.com/2022/10/14/xdz49f.png",
        "https://s1.ax1x.com/2022/10/14/xwZEcR.png",
      ],
      exampletitle: [
        "红环路智慧社区",
        "章贡区中医院慢病管理中心",
        "赣江社区慢病管理中心",
        "联通5G展厅",
      ],

      //服务案列轮播
      examplelist: [
        {
          isshow: true,
          url: "https://s1.ax1x.com/2022/10/13/xaOEFS.jpg",
        },
        {
          isshow: false,
          url: "https://s1.ax1x.com/2022/10/13/xaLUVf.png",
        },
        {
          isshow: false,
          url: "https://s1.ax1x.com/2022/10/13/xaLaa8.jpg",
        },
        {
          isshow: false,
          url: "https://s1.ax1x.com/2022/10/13/xaLdIS.jpg",
        },
      ],
      //新闻列表
      newslist: [],
      swiperOption: {
        // slidesPerView: 1,
        // spaceBetween: 30,
        autoplay: true, //设置可自动播放
        speed: 1000, //自动播放的速度，每隔1秒滑动一次
        loop: true,
        pagination: {
          el: ".swiper-pagination", //分页器的类名
          clickable: true, //设置分页小圆点可手动点击
        },
      },
      //服务案列轮播设置
      exampleswiperOption: {
        // slidesPerView: 1,
        // spaceBetween: 30,
        autoplay: false, //设置可自动播放
        speed: 1000, //自动播放的速度，每隔1秒滑动一次
        loop: false,
        initialSlide: 3,
        pagination: {
          el: ".swiper-pagination", //分页器的类名
          clickable: true, //设置分页小圆点可手动点击
        },
      },
    };
  },

  //挂载时添加监听事件
  mounted() {
    window.addEventListener("scroll", this.scrollHandle); //绑定页面滚动事件
  },
  created() {
    this.GetData();
  },
  methods: {
    // 获取页面滚动高度
    scrollHandle(e) {
      this.top = e.srcElement.scrollingElement.scrollTop; // 获取页面滚动高度
      console.log(this.top);
    },
    //解决方案详情
    soultiondetail(current_type) {
      console.log(current_type);
      this.$router.push({
        path: "/Solutions",
        query: { current_type: current_type },
      });
    },
    change() {
      console.log("切换");
      this.exampleswiperOption.initialSlide = 2;
      console.log(this.exampleswiperOption.initialSlide);
    },
    lookmore() {
      this.$router.push("/News");
      // alert("查看更多");
    },
    //查看新闻详情
    newsdetail(url) {
      window.open(url, "_blank"); // 在新窗口打开外链接
      // window.location.href = 'https://mp.weixin.qq.com/s/v6asHP9CxFJVaTMDxK2HUg' //在本窗口打开外链接
    },
    topnewsdetail() {},
    //服务案列切换
    SwiperChange(position) {
      this.current_swiper = position;
      for (let index = 0; index < this.examplelist.length; index++) {
        this.examplelist[index].isshow = false;
        if (position == index) {
          this.examplelist[position].isshow = true;
        }
      }
      // console.log(index);
      // this.current_swiper = index;
      // this.isshow = false;
      // this.isshow=true
    },
    async GetData() {
      const params = {
        // page: 1
        pageSize: 4,
        currentPage: 1,
      };
      const res = await GetNews(params);
      console.log("请求成功返回数据");
      console.log(res);
      if (res.code == 200) {
        this.newslist = res.result.items.slice(1, res.result.items.length);
        this.topnewstitle = res.result.items[0].title;
        this.topnewsimg =res.result.items[0].cover;
        this.topnewsurl = res.result.items[0].url;
      }
    },
  },
  watch: {
    top(v) {
      if (v > 40) {
        this.isShowTop = false;
      }
      if (v < 50) {
        this.isShowTop = true;
      }
    },
  },
};
</script>

<style lang="less" scoped>
a {
  text-decoration: none;
}
.homebanner {
  min-width: 1200px;
  width: 100%;
  margin-bottom: 47px;
  img {
    width: 100%;
  }
  .swiper-pagination {
    margin-bottom: 20px;
  }
  /deep/.swiper-pagination-bullet {
    width: 72px;
    height: 3px;
    opacity: 0.5;
    background-color: #f5f5f5;
    border-radius: 0px;
  }
  /deep/.swiper-pagination-bullet-active {
    background-color: #f5f5f5;
    width: 72px;
    border-radius: 0px;
    opacity: 1;
    height: 3px;
  }
}

:root {
  --d: 700ms;
  --e: cubic-bezier(0.19, 1, 0.22, 1);
}

.info-wrap {
  margin-bottom: 65px;
  .title-row {
    margin-top: 128px;
    text-align: center;
    margin-bottom: 48px;
    .title {
      margin-top: 17px;
      font-size: 38px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #333333;
    }
    .sub-title {
      margin-top: 5px;
      margin-bottom: 10px;
      font-size: 16px;
      font-weight: bold;
      color: #a2a2a2;
    }
    .line {
      width: 30px;
      height: 4px;
      margin: 0 auto;
      background: #2525cc;
    }
  }
  // 解决方案
  .info-content {
    display: flex;
    justify-content: center;
    grid-gap: 1rem;
    width: 90%;
    margin: 0 auto;

    .solution {
      cursor: pointer;
      position: relative;
      display: flex;
      align-items: flex-end;
      overflow: hidden;
      height: 520px;
      width: 446px;
      text-align: center;
    }

    #solution1 {
      height: 520px;
      width: 446px;
      background-image: url("https://s1.ax1x.com/2022/10/12/xUbqvq.png");
      background-size: 100% 100%;
      /* filter: blur(10px); */
    }
    #solution2 {
      height: 520px;
      width: 446px;
      background-image: url("https://s1.ax1x.com/2022/10/13/xdpcU1.png");
      background-size: 100% 100%;
      /* filter: blur(10px); */
    }
    #solution3 {
      height: 520px;
      width: 446px;
      background-image: url("https://s1.ax1x.com/2022/10/13/xdpIDH.png");
      background-size: 100% 100%;
      /* filter: blur(10px); */
    }

    .solution:after {
      content: "";
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 200%;
      pointer-events: none;
      background-image: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.009) 11.7%,
        rgba(0, 0, 0, 0.034) 22.1%,
        rgba(0, 0, 0, 0.072) 31.2%,
        rgba(0, 0, 0, 0.123) 39.4%,
        rgba(0, 0, 0, 0.182) 46.6%,
        rgba(0, 0, 0, 0.249) 53.1%,
        rgba(0, 0, 0, 0.32) 58.9%,
        rgba(0, 0, 0, 0.394) 64.3%,
        rgba(0, 0, 0, 0.468) 69.3%,
        rgba(0, 0, 0, 0.54) 74.1%,
        rgba(0, 0, 0, 0.607) 78.8%,
        rgba(0, 0, 0, 0.668) 83.6%,
        rgba(0, 0, 0, 0.721) 88.7%,
        rgba(0, 0, 0, 0.762) 94.1%,
        rgba(0, 0, 0, 0.79) 100%
      );
      transform: translateY(-50%);
      transition: all 1s;
    }

    .content {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      height: 100%;
      padding: 1rem;
      transition: transform var(--d) var(--e);
      z-index: 1;
      background: rgba(5, 5, 216, 0.39);
    }

    .content > * + * {
      margin-top: 1rem;
      // margin-top: 110px;
    }

    .title {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 18px;
      color: white;
      line-height: 1.2;
    }

    .descript {
      font-size: 14px;
      line-height: 1.35;
      color: white;
      margin-top: 40px;
    }

    @media (hover: hover) and (min-width: 600px) {
      .solution:after {
        transform: translateY(0);
      }
      .content {
        transition: all 0.5s;

        transform: translateY(calc(100% - 7rem));
      }
      .content > *:not(.title) {
        opacity: 0;
        transform: translateY(1rem);
        transition: all 0.5s;
      }
      .solution:hover,
      .solution:focus-within {
        align-items: center;
      }
      .solution:hover:before,
      .solution:focus-within:before {
        transform: translateY(-4%);
      }
      .solution:hover:after,
      .solution:focus-within:after {
        transform: translateY(-50%);
      }
      .solution:hover .content,
      .solution:focus-within .content {
        transform: translateY(0);
      }
      .solution:hover .content > *:not(.title),
      .solution:focus-within .content > *:not(.title) {
        opacity: 1;
        transform: translateY(0);
        transition-delay: calc(var(--d) / 8);
      }
      .solution:focus-within:before,
      .solution:focus-within:after,
      .solution:focus-within .content,
      .solution:focus-within .content > *:not(.title) {
        transition-duration: 0s;
      }
    }
  }
}
//服务案列
.example-wrap {
  margin-bottom: 65px;
  .swiperchange{
    width: 73%;
    display: flex;
    align-items: flex-start;
  }
  .title-row {
    margin-bottom: 48px;
    text-align: center;
    .title {
      margin-top: 17px;
      font-size: 38px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #333333;
    }
    .sub-title {
      margin-top: 5px;
      margin-bottom: 10px;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #a2a2a2;
      letter-spacing: 2px;
    }
    .line {
      width: 30px;
      height: 4px;
      margin: 0 auto;
      background: #2525cc;
    }
  }
  .div_example {
    width: 90%;
    display: flex;
    justify-content: center;
    padding: 1rem;
    margin: 0 auto;
    // .transition-box {
    //   overflow: hidden;
    //   display: flex;
    //   align-content: center;
    //   justify-content: center;
    // }
    @-webkit-keyframes fadeIn {
      0% {
        opacity: 0; /*初始状态 透明度为0*/
      }
      50% {
        opacity: 0.9; /*中间状态 透明度为0*/
      }
      100% {
        opacity: 1; /*结尾状态 透明度为1*/
      }
    }
    .transition-box {
      -webkit-animation-name: fadeIn; /*动画名称*/
      -webkit-animation-duration: 3s; /*动画持续时间*/
      -webkit-animation-iteration-count: 1; /*动画次数*/
      -webkit-animation-delay: 0s; /*延迟时间*/
    }
  }
}
//新闻中心
.news-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .title-row {
    margin-top: 48px;
    text-align: center;
    margin-bottom: 48px;
    .title {
      margin-top: 17px;
      font-size: 38px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #333333;
    }
    .sub-title {
      margin-top: 5px;
      margin-bottom: 10px;
      font-size: 16px;
      font-weight: bold;
      color: #a2a2a2;
    }
    .line {
      width: 30px;
      height: 4px;
      margin: 0 auto;
      background: #2525cc;
    }
  }
  .iconcolor {
    color: #a2a2a2;
  }
  //新闻列表
  .news {
    width: 80%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    margin: 0 auto;
    .div_newsimg {
      width: 400px;
      cursor: pointer;
      margin-left: 30px;
      // .topnewsimg{
      //   transition: all 0.6s;
      // }
      .topnewsimg{
        
        border: 3px solid white;
      }
      .topnewsimg:hover {
        border: 3px solid #2525cc;
      }
      .topnewstitle {
        overflow: hidden;
        text-overflow: ellipsis;
        -ms-text-overflow: ellipsis;
        white-space: nowrap;
        position: relative;
        bottom: 40px;
        color: white;
        height: 37px;
        width: 400px;
        padding-right: 30px;
        padding-left: 14px;
        padding-top: 10px;
        font-size: 16px;
        background: rgba(0, 0, 0, 0.39);
        opacity: 0.5;
      }
    }

    // .newslitst .div-content .content:hover {
    //   color: #2525cc;
    // }
    // .newslitst .div-title .title:hover {
    //   color: #2525cc;
    // }

    .newslitst:hover {
      .div-title {
        .title {
          color: #2525cc;
        }
        .date {
          color: #2525cc;
        }
      }
      .div-content {
        .content {
          color: #2525cc;
        }
        .iconcolor {
          color: #2525cc;
        }
      }
      .progress2 {
        .progress-bar1 {
          width: 100%;
          background-color: blue;
          animation: progressAnimation 1s;
        }
      }
    }

    .newslitst {
      width: 670px;
      margin-left: 30px;
      display: flex;
      flex-direction: column;
      //新闻标题
      .div-title {
        display: flex;
        align-items: flex-end;
        .title {
          color: black;
          margin-right: 32px;
          flex: 1;
          font-size: 22px;
          overflow: hidden;
          text-overflow: ellipsis;
          -ms-text-overflow: ellipsis;
          white-space: nowrap;
        }
        .date {
          color: #a5a5a5;
          margin-right: 14px;
          font-size: 14px;
        }
      }
      //新闻内容
      .div-content {
        margin-top: 10px;
        justify-content: center;
        align-items: center;
        display: flex;
        .content {
          margin-right: 92px;
          font-size: 14px;
          color: #a5a5a5;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2; //多行在这里修改数字即可
          -webkit-box-orient: vertical;
        }
      }
      //进度条
      .line {
        border-bottom: 2px solid #e6e6e6;
        margin: 18px 0;
      }
      .progress2 {
        margin: 18px 0;
        background: #e6e6e6;
      }

      .progress-bar1 {
        height: 1px;
        transition: 0.1s linear;
        transition-property: width, background-color;
      }

      @keyframes progressAnimation {
        0% {
          width: 5%;
          background-color: blue;
        }
        100% {
          width: 100%;
          background-color: blue;
        }
      }
    }
  }
  //查看更多
  .more {
    cursor: pointer;
    margin-top: 60px;
    margin-bottom: 140px;
    width: 142px;
    height: 42px;
    border: 1px solid blue;
    text-align: center;
    line-height: 42px;
    color: blue;
    font-size: 14px;
    border-radius: 10px;
    cursor: pointer;
    a {
      color: blue;
    }
  }
  .more:hover {
    background: blue;
    a {
      color: white;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Mobile/MobileHome.vue